// apps/spa/src/components/audit/AuditActionBadge.tsx
// Maps an audit action string to a colored Badge label.
//
// Color mapping (per PLAN must_haves + CONTEXT badge labels):
//   created (blue)     — *.create (reminder.create, command.create)
//   updated (green)    — *.update (reminder.update, command.update)
//   deleted (red)      — *.delete (reminder.delete, command.delete)
//   posted (purple)    — reminder.post_now
//   auto-posted (grey) — reminder.dispatch (Phase 5+ cron rows)
//   DM test (grey)     — reminder.dm_test
//   logged in (grey)   — auth.login
//   logged out (grey)  — auth.logout

import { Badge } from '@/components/ui/badge';

const ACTION_META: Record<string, { label: string; className: string }> = {
  'reminder.create':   { label: 'created',     className: 'bg-blue-600 text-white hover:bg-blue-600' },
  'reminder.update':   { label: 'updated',     className: 'bg-green-600 text-white hover:bg-green-600' },
  'reminder.delete':   { label: 'deleted',     className: 'bg-red-600 text-white hover:bg-red-600' },
  'reminder.post_now': { label: 'posted',      className: 'bg-purple-600 text-white hover:bg-purple-600' },
  'reminder.dispatch': { label: 'auto-posted', className: 'bg-gray-500 text-white hover:bg-gray-500' },
  'reminder.dm_test':  { label: 'DM test',     className: 'bg-gray-500 text-white hover:bg-gray-500' },
  'command.create':    { label: 'created',     className: 'bg-blue-600 text-white hover:bg-blue-600' },
  'command.update':    { label: 'updated',     className: 'bg-green-600 text-white hover:bg-green-600' },
  'command.delete':    { label: 'deleted',     className: 'bg-red-600 text-white hover:bg-red-600' },
  'auth.login':        { label: 'logged in',   className: 'bg-gray-500 text-white hover:bg-gray-500' },
  'auth.logout':       { label: 'logged out',  className: 'bg-gray-500 text-white hover:bg-gray-500' },
};

interface AuditActionBadgeProps {
  action: string;
}

export function AuditActionBadge({ action }: AuditActionBadgeProps) {
  const meta = ACTION_META[action] ?? { label: action, className: 'bg-gray-400 text-white hover:bg-gray-400' };
  return (
    <Badge className={meta.className}>
      {meta.label}
    </Badge>
  );
}
